import { Injectable } from '@angular/core';
import { UserUIProfile } from 'BI-Libraries/BI-Components/projects/bi-modules/src/lib/models/UserUIProfile';
import { map, Observable, of } from 'rxjs';

interface CachedProfile {
  profile: UserUIProfile;
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class CashingUserUIProfileService {
  private localStorageKey: string = 'UserUIProfile';
  private maxScreensCashed: number = 50;

  constructor() { }

  public Cash(screenUrl: string, userUIProfile: UserUIProfile): void {
    const cachedProfiles = this.getCachedProfiles();
    cachedProfiles.set(screenUrl, { profile: userUIProfile, timestamp: Date.now() });
    this.deleteOldestIfFilled(cachedProfiles);
    this.setCachedProfiles(cachedProfiles);
  }

  public RemoveCash(){
    localStorage.removeItem(this.localStorageKey);
  }

  public GetMaxTimestampFromUserUIProfile(): string {
    const storedData = localStorage.getItem(this.localStorageKey);
    if (!storedData) {
      return null;
    }
    const userProfiles: any[] = JSON.parse(storedData);
    const timestamps = userProfiles.map(([_, data]) => data.timestamp);
    if(timestamps.length == 0)
      return null;

    const maxTimestamp = new Date(Math.max(...timestamps));
    const compatableMaxTime = maxTimestamp.toISOString()
    return compatableMaxTime;
  }

  public getUserUIProfile(screenUrl: string): Observable<UserUIProfile | null> {
    return of(this.getCachedProfiles()).pipe(
      map(cachedProfiles => {
        const cachedProfile = cachedProfiles.get(screenUrl);
        if (cachedProfile?.profile) {
          return cachedProfile.profile;
        }
        // If expired or not found, return null
        return null;
      })
    );
  }

  private getCachedProfiles(): Map<string, CachedProfile> {
    const cachedData = localStorage.getItem(this.localStorageKey);
    if (cachedData) {
      const parsedData = JSON.parse(cachedData) as [string, CachedProfile][];
      return new Map<string, CachedProfile>(parsedData);
    }
    return new Map<string, CachedProfile>();
  }

  private setCachedProfiles(cachedProfiles: Map<string, CachedProfile>): void {
    const dataToStore = Array.from(cachedProfiles.entries());
    localStorage.setItem(this.localStorageKey, JSON.stringify(dataToStore));
  }

  private deleteOldestIfFilled(cachedProfiles: Map<string, CachedProfile>): void {

    if (cachedProfiles.size > this.maxScreensCashed) {
      const sortedEntries = Array.from(cachedProfiles.entries())
        .sort((a, b) => a[1].timestamp - b[1].timestamp);
      
      const oldestEntry = sortedEntries[0];
      if (oldestEntry) {
        cachedProfiles.delete(oldestEntry[0]);
      }
    }
  }
}
